export const key = process.env.STRIPE_SECRET